/* eslint-disable no-shadow,no-param-reassign,no-return-assign,no-sequences */
import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import networkApi from '@/api/network';

import mapFunctions from '@/mixins/mapFunctions';
import transformers from '@/mixins/transformers';
import EventBus from '@/events/event-bus';
import * as dataCache from '@/store/cache/dataCache';

const state = {
  updated_at: null,
  actionImageTypes: {},
  actionPriorities: {},
  actionStatuses: {},
  attributes: {},
  attributeGroups: {},
  dynamicActionTypes: {},
  dynamicActionTypeCategories: {},
  keyValues: {},
  childIds: {},
  mapObjectCategories: {},
  mapObjectSelectionTypes: {},
  mapObjectStatuses: {},
  mapObjectTypes: {},
  mapObjectTypeMapObjectStatuses: {},
  mapObjectTypeActionStatuses: {},
  teams: {},
  users: {},
  networkModel: null,
  preferredSaveButton: null,

  filter: {},

  loadingSettings: false,
  loadingActions: false,
  loadingMapObjects: false,
  loadingSelections: false,
  settingsLoadedAt: null,
  actionsLoadedAt: null,
  mapObjectsLoadedAt: null,
  selectionsLoadedAt: null,
};

const actions = {
  forceFetchAllNetwork({ commit, dispatch }) {
    commit('SET_ACTIONS_LOADED_AT', null);
    commit('SET_MAP_OBJECTS_LOADED_AT', null);
    commit('SET_SELECTIONS_LOADED_AT', null);
    commit('SET_SETTINGS_LOADED_AT', null);
    commit('SET_LOADING_ACTIONS', false);
    commit('SET_LOADING_MAP_OBJECTS', false);
    commit('SET_LOADING_SETTINGS', false);
    dispatch('fetchAllNetwork');
  },
  fetchAllNetwork({ dispatch }) {
    dispatch('fetchActions');
    dispatch('fetchMapObjects');
    dispatch('fetchSelections');
    dispatch('fetchSettings');
  },
  fetchSettings({ commit, state }) {
    if (state.settingsLoadedAt !== null && state.settingsLoadedAt > (Date.now() - (60000 * 10))) {
      return '';
    }
    if (state.loadingSettings) {
      return '';
    }
    if (localStorage.getItem('network_id') === null) {
      return null;
    }
    commit('SET_LOADING_SETTINGS', true);
    return networkApi.getNetworkSettings(localStorage.getItem('network_id'))
      .then((response) => {
        console.log('Fetched Network settings');
        const actionImageTypes = response.actionImageTypes.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_ACTION_IMAGE_TYPES', actionImageTypes);

        const actionPriorities = response.actionPriorities.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_ACTION_PRIORITIES', actionPriorities);

        const actionStatuses = response.actionStatuses.data
          .sort((a, b) => (a.weight > b.weight ? 1 : -1));
        const openStatusIds = actionStatuses
          .filter(status => status.actionRoleStatus.data.is_open === true)
          .map(item => item.id);
        dataCache.setOpenActionStatusIds(openStatusIds);
        commit('SET_ACTION_STATUSES', actionStatuses.reduce(mapFunctions.reduceFunc, {}));

        const attributes = response.attributes.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_ATTRIBUTES', attributes);

        const attributeGroups = response.attributeGroups.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_ATTRIBUTE_GROUPS', attributeGroups);

        const dynamicActionTypes = response.dynamicActionTypes.data
          .reduce(mapFunctions.reduceFunc, {});
        commit('SET_DYNAMIC_ACTION_TYPES', dynamicActionTypes);

        const dynamicActionTypeCategories = response.dynamicActionTypeCategories.data
          .reduce(mapFunctions.reduceFunc, {});
        commit('SET_DYNAMIC_ACTION_TYPE_CATEGORIES', dynamicActionTypeCategories);

        commit('SET_KEY_VALUES', response.keyValues.data);

        const mapObjectCategories = response.mapObjectCategories.data
          .reduce(mapFunctions.reduceFunc, {});
        commit('SET_MAP_OBJECT_CATEGORIES', mapObjectCategories);

        const mapObjectSelectionTypes = response.mapObjectSelectionTypes.data
          .reduce(mapFunctions.reduceFunc, {});
        commit('SET_MAP_OBJECT_SELECTION_TYPES', mapObjectSelectionTypes);

        const mapObjectStatuses = response.mapObjectStatuses.data
          .sort((a, b) => (a.weight > b.weight ? 1 : -1)).reduce(mapFunctions.reduceFunc, {});
        commit('SET_MAP_OBJECT_STATUSES', mapObjectStatuses);

        const mapObjectTypes = response.mapObjectTypes.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_MAP_OBJECT_TYPES', mapObjectTypes);

        const mapObjectTypeMapObjectStatuses = response.mapObjectTypeMapObjectStatuses.data;
        commit('SET_MAP_OBJECT_TYPE_MAP_OBJECT_STATUSES', mapObjectTypeMapObjectStatuses);

        const mapObjectTypeActionStatuses = response.mapObjectTypeActionStatuses.data;
        commit('SET_MAP_OBJECT_TYPE_ACTION_STATUSES', mapObjectTypeActionStatuses);

        const teams = response.teams.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_TEAMS', teams);

        const users = response.users.data.reduce(mapFunctions.reduceFunc, {});
        commit('SET_USERS', users);

        commit('SET_SETTINGS_LOADED_AT', Date.now());
        commit('SET_LOADING_SETTINGS', false);
        console.log('Committed all Network settings');
        return '';
      })
      .catch((e) => {
        console.log('there has been an error in fetchSettings!', e);
      });
  },
  fetchActions({ commit, state }) {
    if (state.actionsLoadedAt !== null && state.actionsLoadedAt > (Date.now() - (60000 * 10))) {
      return '';
    }
    if (localStorage.getItem('network_id') === null) {
      return null;
    }
    if (state.loadingActions) {
      return '';
    }
    commit('SET_LOADING_ACTIONS', true);
    return networkApi.getNetworkActions(localStorage.getItem('network_id'))
      .then((response) => {
        console.log('Fetched Network actions');
        let resultData = null;
        if (response && response.data) {
          resultData = response.data;
        } else {
          resultData = response;
        }
        const actions = resultData.map(item => transformers.transformAction(item)).reduce(mapFunctions.reduceFunc, {});
        dataCache.setActions(actions);

        if (state.loadingMapObjects === false) {
          dataCache.createIndexesForActionsAndMapObjects();
        }

        commit('SET_ACTIONS_LOADED_AT', Date.now());
        commit('SET_LOADING_ACTIONS', false);
        console.log('Committed all Network actions');
        return '';
      })
      .catch((e) => {
        console.log('there has been an error in fetchActions!', e);
      });
  },
  fetchMapObjects({ commit, state }) {
    if (state.mapObjectsLoadedAt !== null
      && state.mapObjectsLoadedAt > (Date.now() - (60000 * 10))) {
      return '';
    }
    if (localStorage.getItem('network_id') === null) {
      return null;
    }
    if (state.loadingMapObjects) {
      return '';
    }
    commit('SET_LOADING_MAP_OBJECTS', true);
    return networkApi.getNetworkMapObjects(localStorage.getItem('network_id'))
      .then((response) => {
        console.log('Fetched Network data');

        const startTime = performance.now();
        let mapObjects = response;
        mapObjects = mapObjects.map(mapObject => transformers.transformMapObject(mapObject));
        const startTime2 = performance.now();
        dataCache.setMapObjects(mapObjects.reduce(mapFunctions.reduceFunc, {}));
        const startTime3 = performance.now();

        if (state.loadingActions === false) {
          dataCache.createIndexesForActionsAndMapObjects();
        }

        commit('SET_MAP_OBJECTS_LOADED_AT', Date.now());
        commit('SET_LOADING_MAP_OBJECTS', false);
        console.log('Committed all Network data');
        const endTime = performance.now();
        console.log(`MapObjects Mapping took ${startTime2 - startTime} milliseconds`);
        console.log(`MapObjects committing took ${startTime3 - startTime2} milliseconds`);
        console.log(`MapObjects sorting took ${endTime - startTime3} milliseconds`);
        return mapObjects;
      })
      .catch((e) => {
        console.log('there has been an error in fetchMapObjects!', e);
      });
  },
  fetchSelections({ commit, state }) {
    if (state.selectionsLoadedAt !== null
      && state.selectionsLoadedAt > (Date.now() - (60000 * 10))) {
      return '';
    }
    if (localStorage.getItem('network_id') === null) {
      return null;
    }
    if (state.loadingSelections) {
      return '';
    }
    commit('SET_LOADING_SELECTIONS', true);
    return networkApi.getNetworkSelections(localStorage.getItem('network_id'))
      .then((response) => {
        console.log('Fetched Network selections');
        const mapObjectSelections = response.data
          .reduce(mapFunctions.reduceFunc, {});
        dataCache.setSelections(mapObjectSelections);

        commit('SET_SELECTIONS_LOADED_AT', Date.now());
        commit('SET_LOADING_SELECTIONS', false);
        console.log('Committed all Network selections');
        return '';
      })
      .catch((e) => {
        console.log('there has been an error in fetchSelections!', e);
      });
  },
  fetchNetwork({ commit }) {
    if (!localStorage.getItem('network_id')) {
      return null;
    }
    return networkApi.getNetworkById(localStorage.getItem('network_id'))
      .then((response) => {
        commit('SET_NETWORK', response.data);
        return response.data;
      })
      .catch(() => {
      });
  },
  setCurrentPreferredSaveButton({ commit }, payload) {
    return commit('SET_PREFERRED_SAVE_BUTTON', payload.button);
  },
  getChildrenForMapObject(_, { id }) {
    return dataCache.getChildrenForMapObjectId(id);
  },
  getChildrenIdsForMapObjectIds(_, { ids, onlyDirectChildren = false }) {
    const children = [];
    ids.forEach((id) => {
      dataCache.getChildrenIdsForMapObjectId(id, onlyDirectChildren).forEach((child) => {
        children.push(child);
      });
    });
    return children;
  },
  async getParentsForMapObject({ dispatch }, { mapObject }) {
    if (mapObject.parent_id === null) {
      return null;
    }
    const parentResult = Object.values(dataCache.getMapObjects()).filter(
      item => item.id === mapObject.parent_id,
    );
    if (parentResult.length === null) {
      return null;
    }
    if (parentResult[0].parent_id !== null) {
      const upperParents = await dispatch('getParentsForMapObject', { mapObject: parentResult[0] });
      parentResult.concat(upperParents);
    }
    return parentResult;
  },
  getLinestringsByStartOrEndPoint(_, { id }) {
    return Object.values(dataCache.getMapObjects()).filter((item) => {
      if (item.geoObject && item.geoObject.data && item.geoObject.data.properties
        && (item.geoObject.data.properties.start_point === id
          || item.geoObject.data.properties.end_point === id)
      ) {
        return true;
      }
      return item.start_point === id || item.end_point === id;
    });
  },
  getActionsForMapObjectId(_, { id }) {
    return Object.values(dataCache.getActions()).filter(item => item.map_object_id === id);
  },
  getActionsForMapObjectIds(_, { ids }) {
    return Object.values(dataCache.getActions()).filter(item => ids.includes(item.map_object_id));
  },
  setFilter({ commit }, { filter }) {
    console.log('SET_FILTER', filter);
    commit('SET_FILTER', filter);
    // commit('RESET_MAP');
  },
  resetFilter({ commit }) {
    console.log('SET_FILTER', {});
    commit('SET_FILTER', {});
    // commit('RESET_MAP');
  },
  getActions() {
    return dataCache.getActions();
  },
  addAction(_, { action }) {
    console.log('addAction', action);
    dataCache.upsertAction(action);
    EventBus.$emit('data.createAction', action.id);
    if (action.map_object_id !== null) {
      const mapObject = dataCache.getMapObjectById(action.map_object_id);
      if (mapObject) {
        EventBus.$emit('Map.redrawMapObject', mapObject);
      }
    } else {
      EventBus.$emit('Map.drawActionOnMap', action);
    }
  },
  updateAction(_, { action }) {
    dataCache.upsertAction(action);
    EventBus.$emit('data.updateAction', action.id);
    if (action.map_object_id !== null) {
      const mapObject = dataCache.getMapObjectById(action.map_object_id);
      if (mapObject) {
        EventBus.$emit('Map.redrawMapObject', mapObject);
        if (mapObject.parent_id) {
          const parent = dataCache.getMapObjectById(mapObject.parent_id);
          EventBus.$emit('Map.redrawMapObject', parent);
          if (parent.parent_id) {
            const grandparent = dataCache.getMapObjectById(parent.parent_id);
            EventBus.$emit('Map.redrawMapObject', grandparent);
          }
        }
      }
    } else {
      EventBus.$emit('Map.redrawActionOnMap', action);
    }
  },
  removeAction(_, { actionId }) {
    const action = dataCache.getActionById(actionId);
    dataCache.removeAction(actionId);
    if (!action) {
      EventBus.$emit('Map.removeActionFromMap', actionId);
      return;
    }
    if (action.map_object_id !== null) {
      const mapObject = dataCache.getMapObjectById(action.map_object_id);
      if (mapObject) {
        EventBus.$emit('Map.redrawMapObject', mapObject);
      }
    } else {
      EventBus.$emit('Map.removeActionFromMap', actionId);
    }
  },
  getMapObjectById(_, { mapObjectId }) {
    return dataCache.getMapObjectById(mapObjectId);
  },
  getMapObjects() {
    return dataCache.getMapObjects();
  },
  addMapObject({ commit, state }, { mapObject }) {
    if (mapObject.parent_id) {
      const parent = dataCache.getMapObjectById(mapObject.parent_id);
      if (parent) {
        if (parent.children) {
          parent.children.push(mapObject);
        } else {
          parent.children = [mapObject];
        }
        dataCache.upsertMapObject(parent);
        const { childIds } = state;
        if (childIds[mapObject.parent_id]) {
          childIds[mapObject.parent_id].push(mapObject.id);
        } else {
          childIds[mapObject.parent_id] = [mapObject.id];
        }
        commit('SET_CHILD_IDS', childIds);
      }
    }
    dataCache.upsertMapObject(mapObject);
    EventBus.$emit('Map.redrawMapObject', mapObject);
  },
  updateMapObject(_, { mapObject, redraw = true }) {
    console.log('settings.updateMapObject', mapObject);
    const startTime = performance.now();
    const cachedMapObjects = dataCache.getMapObjects();
    const oldMapObject = cachedMapObjects[mapObject.id]
      ? JSON.parse(JSON.stringify(cachedMapObjects[mapObject.id])) : {};
    const newMapObject = JSON.parse(JSON.stringify(mapObject));
    if (oldMapObject.parent_id !== newMapObject.parent_id) {
      const oldParent = dataCache.getMapObjectById(oldMapObject.parent_id);
      if (oldParent) {
        dataCache.upsertMapObject(oldParent);
      }

      if (newMapObject.parent_id !== null) {
        const newParent = dataCache.getMapObjectById(newMapObject.parent_id);
        if (newParent) {
          dataCache.upsertMapObject(newParent);
        }
      }
    }
    if (redraw) {
      EventBus.$emit('Map.redrawMapObject', mapObject);
    }
    dataCache.upsertMapObject(mapObject);
    const endTime = performance.now();
    console.log(`settings.updateMapObject took ${endTime - startTime} milliseconds`);
  },
  updateObstructionOfMapObject(_, { mapObjectId, isObstructed = false }) {
    const mapObject = JSON.parse(JSON.stringify(dataCache.getMapObjectById(mapObjectId)));
    if (!mapObject) {
      return;
    }
    mapObject.is_obstructed = isObstructed;
    dataCache.upsertMapObject(mapObject);
    EventBus.$emit('Map.redrawMapObject', mapObject);
  },
  removeMapObject({ commit, state }, { mapObjectId }) {
    const { childIds } = state;
    const mapObject = JSON.parse(JSON.stringify(dataCache.getMapObjectById(mapObjectId)));
    if (!mapObject) {
      return;
    }
    if (mapObject.parent_id !== null) {
      const parent = JSON.parse(JSON.stringify(dataCache.getMapObjectById(mapObject.parent_id)));
      if (parent) {
        if (parent.children) {
          parent.children = parent.children.filter(item => item.id !== mapObjectId);
        }
        dataCache.upsertMapObject(parent);
      }
      if (childIds[mapObject.parent_id]) {
        childIds[mapObject.parent_id] = childIds[mapObject.parent_id]
          .filter(childId => childId !== mapObjectId);
      }
    }
    dataCache.removeMapObject(mapObjectId);
    if (childIds[mapObjectId]) {
      delete childIds[mapObjectId];
    }
    commit('SET_CHILD_IDS', childIds);
    EventBus.$emit('Map.removeMapObjectFromMap', mapObjectId);
  },
};

const mutations = {
  SET_UPDATED_AT(state, updatedAt) {
    state.updated_at = updatedAt;
  },
  SET_ACTION_IMAGE_TYPES(state, actionImageTypes) {
    Vue.set(state, 'actionImageTypes', actionImageTypes);
  },
  SET_ACTION_PRIORITIES(state, actionPriorities) {
    Vue.set(state, 'actionPriorities', actionPriorities);
  },
  SET_ACTION_STATUSES(state, actionStatuses) {
    Vue.set(state, 'actionStatuses', actionStatuses);
  },
  SET_ATTRIBUTES(state, attributes) {
    Vue.set(state, 'attributes', attributes);
  },
  SET_ATTRIBUTE_GROUPS(state, attributeGroups) {
    Vue.set(state, 'attributeGroups', attributeGroups);
  },
  SET_DYNAMIC_ACTION_TYPES(state, dynamicActionTypes) {
    Vue.set(state, 'dynamicActionTypes', dynamicActionTypes);
  },
  SET_DYNAMIC_ACTION_TYPE_CATEGORIES(state, dynamicActionTypeCategories) {
    Vue.set(state, 'dynamicActionTypeCategories', dynamicActionTypeCategories);
  },
  SET_KEY_VALUES(state, keyValues) {
    Vue.set(state, 'keyValues', keyValues);
  },
  SET_CHILD_IDS(state, childIds) {
    Vue.set(state, 'childIds', childIds);
  },
  SET_MAP_OBJECT_CATEGORIES(state, mapObjectCategories) {
    Vue.set(state, 'mapObjectCategories', mapObjectCategories);
  },
  SET_MAP_OBJECT_SELECTION_TYPES(state, mapObjectSelectionTypes) {
    Vue.set(state, 'mapObjectSelectionTypes', mapObjectSelectionTypes);
  },
  SET_MAP_OBJECT_STATUSES(state, mapObjectStatuses) {
    Vue.set(state, 'mapObjectStatuses', mapObjectStatuses);
  },
  SET_MAP_OBJECT_TYPES(state, mapObjectTypes) {
    Vue.set(state, 'mapObjectTypes', mapObjectTypes);
  },
  SET_MAP_OBJECT_TYPE_MAP_OBJECT_STATUSES(state, mapObjectTypeMapObjectStatuses) {
    Vue.set(state, 'mapObjectTypeMapObjectStatuses', mapObjectTypeMapObjectStatuses);
  },
  SET_MAP_OBJECT_TYPE_ACTION_STATUSES(state, mapObjectTypeActionStatuses) {
    Vue.set(state, 'mapObjectTypeActionStatuses', mapObjectTypeActionStatuses);
  },
  SET_TEAMS(state, teams) {
    Vue.set(state, 'teams', teams);
  },
  SET_USERS(state, users) {
    Vue.set(state, 'users', users);
  },
  SET_NETWORK(state, network) {
    Vue.set(state, 'networkModel', network);
  },
  SET_PREFERRED_SAVE_BUTTON(state, button) {
    state.preferredSaveButton = button;
  },
  SET_FILTER(state, filter) {
    state.filter = filter;
  },
  SET_ACTIONS_LOADED_AT(state, timestamp) {
    state.actionsLoadedAt = timestamp;
  },
  SET_MAP_OBJECTS_LOADED_AT(state, timestamp) {
    state.mapObjectsLoadedAt = timestamp;
  },
  SET_SELECTIONS_LOADED_AT(state, timestamp) {
    state.selectionsLoadedAt = timestamp;
  },
  SET_SETTINGS_LOADED_AT(state, timestamp) {
    state.settingsLoadedAt = timestamp;
  },
  SET_LOADING_ACTIONS(state, loading) {
    state.loadingActions = loading;
  },
  SET_LOADING_MAP_OBJECTS(state, loading) {
    state.loadingMapObjects = loading;
  },
  SET_LOADING_SELECTIONS(state, loading) {
    state.loadingSelections = loading;
  },
  SET_LOADING_SETTINGS(state, loading) {
    state.loadingSettings = loading;
  },
};

const getters = {
  getUpdatedAt: state => state.updated_at,
  getActionImageTypes: state => state.actionImageTypes,
  getActionPriorities: state => state.actionPriorities,
  getActionStatuses: state => state.actionStatuses,
  getSortedActionStatuses: state => Object.values(state.actionStatuses)
    .sort((a, b) => (a.weight > b.weight ? 1 : -1)),
  getAttributes: state => state.attributes,
  getAttributeGroups: state => state.attributeGroups,
  getDynamicActionTypes: state => state.dynamicActionTypes,
  getDynamicActionTypeCategories: state => state.dynamicActionTypeCategories,
  getKeyValues: state => state.keyValues,
  getChildIds: state => state.childIds,
  getMapObjectCategories: state => state.mapObjectCategories,
  getMapObjectSelectionTypes: state => state.mapObjectSelectionTypes,
  getMapObjectStatuses: state => state.mapObjectStatuses,
  getMapObjectTypes: state => state.mapObjectTypes,
  getMapObjectTypeMapObjectStatuses: state => state.mapObjectTypeMapObjectStatuses,
  getMapObjectTypeActionStatuses: state => state.mapObjectTypeActionStatuses,
  getTeams: state => state.teams,
  getUsers: state => state.users,
  getNetworkModel: state => state.networkModel,
  getNetworkId: state => (state.networkModel ? state.networkModel.id : null),
  getPreferredSaveButton() {
    return state.preferredSaveButton;
  },
  getFilter: state => state.filter,
  getLoadingActions: state => state.loadingActions,
  getLoadingMapObjects: state => state.loadingMapObjects,
  getLoadingSelections: state => state.loadingSelections,
  getLoadingSettings: state => state.loadingSettings,
  getActionsLoadedAt: state => state.actionsLoadedAt,
  getMapObjectsLoadedAt: state => state.mapObjectsLoadedAt,
  getSelectionsLoadedAt: state => state.selectionsLoadedAt,
  getSettingsLoadedAt: state => state.settingsLoadedAt,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
